import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AjaxContext, AppContext, UserContext } from 'commons-ui';
import uuid from 'react-uuid';
import _get from 'lodash/get';
import dayjs from 'dayjs';

import { IDowntimeBaseInterface, EDowntimeCreator } from '../../utils/constants';

const useCreate = () => {
	const { postData } = useContext(AjaxContext);
	const {
		app: { appName },
		showAlert
	} = useContext(AppContext);
	const { user } = useContext(UserContext);
	const [showLoader, setShowLoader] = useState(false);
	const history = useHistory();

	const handleFormSubmit = async (submittedData: IDowntimeBaseInterface) => {
		try {
			if ((!submittedData?.endTime || !submittedData?.startTime) && !(submittedData?.startTime < submittedData?.endTime)) {
				showAlert(`Error: Please select correct start and end timestamp.`, { type: 'error' });
				return;
			}
			setShowLoader(true);
			const response = await postData({
				endpoint: '/marketing/dashboard/downtime/addDowntimeDetails',
				queryParams: {
					appName
				},
				body: {
					constraintId: uuid(),
					isActive: submittedData?.isActive,
					featureType: submittedData?.featureType,
					paymentMode: submittedData?.paymentMode,
					pgName: submittedData?.pgName,
					instruments: {
						type: submittedData?.instrumentType,
						issuer: submittedData?.issuer,
						network: submittedData?.network,
						cardType: submittedData?.cardType
					},
					downtimeType: submittedData?.downtimeType,
					message: submittedData?.message,
					createdBy: EDowntimeCreator.ZUPEE,
					emailId: _get(user, 'email', ''),
					startTime: dayjs(new Date(Number(submittedData?.startTime))).format('YYYY-MM-DD HH:mm:ss'),
					endTime: dayjs(new Date(Number(submittedData?.endTime))).format('YYYY-MM-DD HH:mm:ss')
				}
			});
			const err: boolean = response?.data && response?.data?.success;
			if (!err) {
				showAlert(
					`Error: Scheduled Downtime creation failed, please try again. ! Error: ${response?.response?.data?.error}`,
					{ type: 'error' }
				);
			} else {
				showAlert('Record created');
				history.goBack();
			}
		} catch (error: any) {
			showAlert(`Error: Scheduled Downtime creation failed, please try again. ! Error: ${error?.response?.data?.error}`, {
				type: 'error'
			});
		} finally {
			setShowLoader(false);
		}
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
